export default "assets/images/f101a0974972eeab41189185a5c5b225.png";